import WrapWithCopy from "@/components/WrapWithCopy.vue";
import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
import Popper from "vue3-popper";
import AppTd from "@/components/AppTd";
import WrapWithStatusIcon from "@/components/seo/WrapWithStatusIcon.vue";
import ProductWithFlagOverlay from "@/components/ProductWithFlagOverlay.vue";
import SeoParentVariationTheme from "@/components/seo/SeoParentVariationTheme.vue";
export default {
  name: "SeoChildProductCell",
  components: {
    AppIcon,
    AppPopover,
    WrapWithCopy,
    Popper,
    AppTd,
    WrapWithStatusIcon,
    ProductWithFlagOverlay,
    SeoParentVariationTheme
  },
  emits: ["onEdit", "onParentLinkBtnClicked"],
  props: {
    item: Object,
    index: Number,
    imgWidth: String,
    imgHeight: String,
    imgBorder: String,
    showNavigationBtn: Number,
    pushModal: Boolean,
    toggleLineHeight: String,
    showPopover: Boolean,
    uid: String,
    last: {
      type: Boolean,
      default: false
    },
    isFiltering: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgWidth: "28px",
      imgHeight: "28px",
      imgBorder: "none",
      isHovering: false,
      cellNotHoverable: false,
      parentLinkColor: "#ADADAD",
      tooltipOn: true
    };
  },
  methods: {
    onImageChange(item) {
      //we comment it temporarily because we might work on the image upload or image processing
      // const originalItem = this.products.find((el) => el.asin == item.asin);

      // this.imageManagerModal = true;
      // this.editAsin = item.asin;
      // this.editImage =
      //   originalItem.image_large ||
      //   originalItem.image_medium ||
      //   originalItem.image_small;

      //temporary solution
      let link = item.amazon_link;
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + link;
      }
      window.open(link, "_blank");
    },
    onMouseOver() {
      this.isHovering = true;
      this.$emit("onCopyingHover", null);
    },
    onMouseLeave() {
      this.isHovering = false;
      this.$emit("onCopyingHoverLeave", null);
    },
    preventCellHover() {
      this.cellNotHoverable = true;
    },
    allowCellHover() {
      this.cellNotHoverable = false;
    },
    parentLinkHover() {
      this.parentLinkColor = "#4C8EFF";
      this.cellNotHoverable = true;
      this.tooltipOn = false;
    },
    parentLinkLeave() {
      this.parentLinkColor = "#ADADAD";
      this.cellNotHoverable = false;
      this.tooltipOn = true;
    },
    onParentLinkBtnClicked(e) {
      e.stopPropagation();
      this.$emit("onParentLinkBtnClicked");
      this.parentLinkColor = "#ADADAD";
    }
  }
};